export default __webpack_public_path__ + "static/eCFPaOEu-4263e30d32ef1a76d08f5070e6850467.svg";